module.exports = __webpack_public_path__ + "static/media/AWAY.9248678c.svg";